var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-list"},_vm._l((_vm.data),function(category){return _c('div',{key:category.id,staticClass:"category-list-item"},[_c('b-card',{staticClass:"overflow-hidden",attrs:{"no-body":""},on:{"click":function($event){return _vm.toCategory(category.slug)}}},[_vm._v(" "+_vm._s(category.name)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }